/* !
 * prodDl.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const sendButton = document.querySelector('.prod-dl-float .js-sendForm');
	const caution = document.querySelector('.prod-dl-float .__caution');
	const countText = document.querySelector('.prod-dl-float .__count span');

	const countCheck = () => {
		// 初期選択カウント（製品ページからの遷移など）
		const checkedItem = document.querySelectorAll('.prod-dl-itemlist input[type="checkbox"]:checked');
		countText.textContent = checkedItem.length;
		if (checkedItem.length > 10) {
			caution.classList.remove('di_none');
			sendButton.disabled = true;
		}

		// チェックがあるアコーディオンを開く
		document.querySelectorAll('.mod-accordion:has(.prod-dl-itemlist input[type="checkbox"]:checked').forEach(ele => {
			if (!ele.getAttribute('open')) {
				ele.setAttribute('open', 'true');
				ele.classList.add('is-visible');
				ele.querySelector('.mod-accordion-plus').animate(
					{ rotate: ['0deg', '90deg'] },
					{
						duration: 300,
						pseudoElement: "::after",
						easing: 'ease',
						fill: 'forwards',
					}
				);
			}
		});
	}

	const setCheckEvent = () => {
		document.querySelectorAll('.prod-dl-itemlist input[type="checkbox"]').forEach(ele => {
			ele.addEventListener('change', () => {
				let count = document.querySelectorAll('.prod-dl-itemlist input[type="checkbox"]:checked').length;
				countText.textContent = count;

				if (count > 0) {
					sendButton.disabled = false;
				} else {
					sendButton.disabled = true;
				}
				if (count > 10) {
					caution.classList.remove('di_none');
					sendButton.disabled = true;
				} else {
					caution.classList.add('di_none');
				}
			});
		});
	}

	const fieldProdList = () => {
		document.querySelectorAll('.js-prodList').forEach(ele => {
			let fieldHTML = '', seriesKey = '';

			ele.querySelectorAll('li').forEach(item => {
				if (item.querySelector('.rt_cf_p_series_key').textContent !== seriesKey) {
					seriesKey = item.querySelector('.rt_cf_p_series_key').textContent;
					if (fieldHTML) {
						fieldHTML += '</ul></div></div></details>';
					}
					fieldHTML += '<details class="mod-accordion js-accordion mod-spacer3">' +
						`<summary class="mod-accordion-summary"><span class="t-body_XLarge fw_700">${item.querySelector('.rt_cf_p_series_name_sds').textContent}</span>` +
						'<span class="mod-accordion-plus" aria-hidden="true"></span></summary>' +
						'<div class="mod-accordion-wrapper"><div class="mod-accordion-content"><ul class="prod-dl-itemlist">';
				}
				fieldHTML += `<li>${item.querySelector('label').outerHTML}</li>`;
			});

			ele.closest('section').insertAdjacentHTML('beforeend', fieldHTML);
			ele.remove();

			countCheck();
			setCheckEvent();
		});
	};

	// ブラウザバック対応
	window.addEventListener('pageshow', () => {
		countCheck();
	});


	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const prodDlFUNCTIONS = () => {
		if (FUNCTIONS.va.pathname === '/product/sds/' || FUNCTIONS.va.pathname === '/product/sds/index.html') {
			fieldProdList();
		} else if (FUNCTIONS.va.pathname === '/product/fs/' || FUNCTIONS.va.pathname === '/product/fs/index.html') {
			countCheck();
			setCheckEvent();
		}
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { prodDlFUNCTIONS(); }) : prodDlFUNCTIONS();

})(window.FUNCTIONS);
